<template>
	<div class="d-flex align-start justify-space-between">
		<v-menu v-model="menuOpen" bottom offset-y :close-on-content-click="false" content-class="cost-table-info-container">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					:color="color"
					v-bind="attrs"
					v-on="on"
					raised
					dark
					:block="buttonBig"
					:icon="!buttonBig"
					small
				>
					<v-icon small>mdi-format-list-checkbox</v-icon>
					<p class="mb-0 ml-1 caption" v-if="buttonBig">Modificar Título</p>
				</v-btn>
			</template>
			<div style="color: black;width: 350px;">
				<div class="d-flex align-start justify-space-between mb-2">
					<p class="mb-1 font-weight-bold caption">Tabla de Costo</p>
				</div>
				<div>
					<ProjectTypeSelectorMenuSelect
						v-if="parentContract"
						inputLabel="Tipo de Proyecto"
						:projectType="projectType"
						:onClick="(project_type) => { changeProjectType(project_type) }"/>

					<div class="my-2">
            <v-form ref="form" v-model="validform">
							<v-text-field
								label="Título Tabla de Costos"
								v-model="costTableTitle"
								outlined
								required
								dense
								hide-details
								:rules="requiredRule"
								class="custom-height-search custom-height-calendar w-100"
							></v-text-field>
						</v-form>
						<p class="mb-0 text-right" style="font-size: 10px;color: grey;">Ingresa un título descriptivo para la tabla de costo</p>
					</div>
					<v-divider class="my-2"></v-divider>
					<div class="d-flex align-center justify-end">
						<div class="d-flex flex-row justify-space-between flex-1">
							<v-btn
								color="#524D4D"
								raised
								dark
								outlined
								small
								@click="closeModal"
							>
								<p class="mb-0 text-primary">Cancelar</p>
							</v-btn>
							<v-btn
								color="#524D4D"
								raised
								dark
								small
								:loading="loading"
								@click="saveCostTableInfo"
							>
								<p class="mb-0">Confirmar</p>
							</v-btn>
						</div>
					</div>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { updateProjectCostInfo } from '@/helpers/api/costs';
import ProjectTypeSelectorMenuSelect from '@/components/Helpers/Components/ProjectTypeSelectorMenuSelect'

export default {
	name: 'CostTableInfoConfig',
	props: {
		project: {
			type: Object,
			required: true
		},
		costsTable: {
			type: Object,
			required: true
		},
		color: {
			type: String,
			required: false,
			default: 'black'
		},
		buttonBig: {
			type: Boolean,
			required: false,
			default: false
		},
		fromModal: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	components: {
		ProjectTypeSelectorMenuSelect
	},
	data() {
		return {
			costTableTitle: this.costsTable?.project_cost_info?.title || null,
			projectType: this.costsTable?.project_cost_info?.project_type || this.project?.info?.project_type || null,
			projectTypeId: this.costsTable?.project_cost_info?.project_type_id || this.project?.info?.project_type?.id || null,
			loading: false,
			menuOpen: false,
			validform: true,
			requiredRule: [
				v => !!v || 'Campo requerido'
			]
		};
	},
	computed: {
		parentContract(){
			return this.costsTable?.contract?.parent_contract
		}
	},
	mounted() {
		// if(!this.costTableTitle && !this.fromModal){
		// 	if((this.$route.hash == '#general' || !this.$route.hash) && !this.parentContract){
		// 		this.$nextTick(() => {
		// 			setTimeout(() => {
		// 				this.menuOpen = true;
		// 			}, 1000);
		// 		});
		// 	}
		// 	else if(this.$route.hash == '#addendums' && this.parentContract){
		// 		this.$nextTick(() => {
		// 			setTimeout(() => {
		// 				this.menuOpen = true;
		// 			}, 1000);
		// 		});
		// 	}
		// }
	},
	methods: {
		closeModal() {
			this.menuOpen = false;
      this.validform = true;
		},
		changeProjectType(project_type) {
			this.projectType = project_type;
			this.projectTypeId = project_type.id;
		},
		async saveCostTableInfo() {
      if(this.$refs.form.validate()){
				const data = {
					project_cost_id: this.costsTable.id,
					title: this.costTableTitle,
					project_type_id: this.projectTypeId
				};
				const updateCostInfo = await updateProjectCostInfo(data);
				if(updateCostInfo.code == 200){
					eventBus.$emit('reloadInformation')
					this.closeModal();
				}
			}
		}
	}
};
</script>

<style scoped>
	.cost-table-info-container{
		background-color: white;
		max-width: 450px;
		min-width: 350px;
		padding: 10px;
		border: 1px solid grey;
		opacity: 1!important;
	}
</style>